const defaultEnvironment = 'prod'

type Environment = 'prod' | 'stage' | 'dev'

const getEnvironment = () => process.env.REACT_APP_ENV as Environment || defaultEnvironment

export default getEnvironment
